




















































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'; // デコレータ
import pack from '../../../package.json';
import router from '../../router';
import axios from 'axios';
import { supervisingModule } from '../../store/modules/OperationSupervising';
import { ScreenName } from '../../CommonUtils/fixed/ScreenName';
import { applicationFormModule } from '../../Uketsuke/store/modules/ApplicationForm';
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル
import ApiAccessBase from '../components/ApiAccessBase.vue';
import { AuthoritiesId } from '@/CommonUtils/fixed/AuthoritiesId';
// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class Menu extends ApiAccessBase {
  private cydeen2AdminFlg: boolean = false; // 管理者権限フラグ
  private unyoKanriFlg: boolean = false; // 運用管理操作権限フラグ
  private eucAuthority: boolean = false;
  private ceAuthority: boolean = false;
  private spare: boolean = false;
  private version = pack.version;
  private logout() {
     axios.post(Constants.KANRI_URL + '/logout')
           .then((response) => {
            // 成功
            router.push({name: ScreenName.LOGOUT});
      });
    }

  private created() {
    this.screenTitle = '総合メニュー';
    this.apiAccess(Constants.DOMAIN_URL + Constants.PROJECT_URL + '/general-menu/init', Constants.API_METHOD_GET, false, false)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        this.cydeen2AdminFlg = this.checkAuthority(AuthoritiesId.ROLE_CYDEEN2_ADMIN);
        // 2023.07.13 [2023F-02] upd start
        //this.unyoKanriFlg = this.checkAuthority(AuthoritiesId.ORG_READ);
        this.unyoKanriFlg = this.checkAuthority(AuthoritiesId.ORG_READ) || this.checkAuthority(AuthoritiesId.MST_READ);
        // 2023.07.13 [2023F-02] upd end
        this.eucAuthority = this.checkAuthority(AuthoritiesId.EUC_CREATE);
        this.ceAuthority = this.checkAuthority(AuthoritiesId.CEF_READ);
      }
     });
  }
}
